import { connect } from 'react-redux';
import LaneDropzone from '../components/lane-dropzone';
import {
  deleteLaneData,
  updateBlockData,
  addBlockData,
  setLaneInfoIsDraggingOver,
  setLaneInfo,
  addMultiBlockData,
  updateMultiPlanningBlockData,
  setBlockPreview,
  setBlockPreviewFailure,
} from '../../../containers/gantt-actions';

const mapStateToProps = state => ({
  view: state.gantt.view,
  ganttDimensions: state.gantt.ganttDimensions,
  viewDimensions: state.gantt.viewDimensions,
  dateReference: state.gantt.dateReference,
  isLoadingBoardData: state.gantt.isLoadingBoardData,
});

const mapDispatchToProps = {
  deleteLaneData,
  updateBlockData,
  addBlockData,
  updateMultiPlanningBlockData,
  setLaneInfoIsDraggingOver,
  setLaneInfo,
  addMultiBlockData,
  setBlockPreview,
  setBlockPreviewFailure,
};

export default connect(mapStateToProps, mapDispatchToProps)(LaneDropzone);
